import { Component, Input, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';

import { Drawer, DrawerRef } from '../../../drawer.service';

@Component({
  selector: 'uex-drawer-footer',
  templateUrl: './footer.component.html',
  host: {
    class: 'uex-drawer-footer modal-footer'
  }
})
export class DrawerFooterComponent implements AfterViewInit, OnDestroy {
  @Input('alignItems') public alignItems = 'center';
  @Input('alignContent') public alignContent: string = null;
  @Input('justifyItems') public justifyItems: string = null;

  constructor(
    private _drawerRef: DrawerRef,
    public elementRef: ElementRef
  ) { }

  private _drawer: Drawer;
  private _index: number;

  public ngAfterViewInit() {
    this._drawer = this._drawerRef.drawer;
    this._index = this._drawer.addFooter(this);
  }

  public ngOnDestroy() {
    this._drawer.removeFooter(this._index);
  }
}
